<template>
  <div class="footer w-100">
    <div class="p-4 text-white">
      <p class="text-center mb-0 beian">©2008-{{curYear}}{{webTitle}}</p>
      <p class=" text-center mb-0 beian">
        {{webSmallTitle}}
      </p>
      <a class="color-88 d-block text-center mb-0 beian" target="_blank" href="https://beian.miit.gov.cn/">
        鲁ICP备2021018723号
      </a>
      <a class="color-88 d-block text-center mb-0 mt-1 beian" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37078402000280">
        <img src="/static/img/index/plice.png" class="mr-1"/>鲁公网安备&nbsp;37078402000280号
      </a>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "indexFooter",
    data(){
      return {
        curYear: '',
      }
    },
    created() {
      this.curYear = new Date().getFullYear();
    },
    computed: {
      ...mapState({
        webTitle: state => state.webTitle,
        webSmallTitle: state => state.webSmallTitle,
      })
    }
  }
</script>

<style scoped>

</style>
